import isNil from '~/_base/functions/isNil';

export default function getFiltersFromLocalStorage(projectId) {
  // console.log('Get filters from local storage')
  if (typeof Storage !== undefined) {
    let storedFilters = localStorage.getItem(
      `ape_liveview_filters_${projectId}`
    );

    if (!isNil(storedFilters)) {
      return JSON.parse(storedFilters);
    }
  }

  return null;
}
